import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import routerData from './modules/routerData'
import role from './modules/role'
import layout from './modules/layout/index'
import eduWebConfig from "./eduwebconfig"

Vue.use(Vuex)
Vue.directive('enterToNext', {
  inserted: function (el) {
    console.log("enterToNext...")
    //let frm = el.querySelector('.el-form');
    let inputs = el.querySelectorAll('input');
    console.log(inputs);
    //绑定回写事件
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].setAttribute("keyFocusIndex", i);
      inputs[i].addEventListener('keyup', (ev) => {
        if (ev.keyCode === 13) {
          let targetTo = ev.srcElement.getAttribute('keyFocusTo');
          if (targetTo) {
            this.$refs[targetTo].$el.focus();
          } else {
            var attrIndex = ev.srcElement.getAttribute('keyFocusIndex');
            var ctlI = parseInt(attrIndex);
            if (ctlI < inputs.length - 1)
              inputs[ctlI + 1].focus();
          }
        }
      });
    }

  },
});
const store = new Vuex.Store({
  state: {
    token: Cookies.get('token'),
    menuIsShow: false
  },
  mutations: {
    setToken(state, token) {

      state.token = token
      Cookies.set('token', token, {
        expires: 1
      });
    }
  },
  actions: {
    setToken({
      commit
    }, token) {
      return new Promise((resolve, reject) => {
        commit('setToken', token)
        resolve()
      })
    }
  },
  getters: {
    isCompany: state => {
      let currenCompany = state.role.companyList.find(item=>item.id == state.role.info.HospitalID);
      return currenCompany ? true : false
    },
    questionInfo: state => state.role.questionInfo,
    url: state => state.layout.url,
    zzHospitalUrl: state => state.layout.zzHospitalUrl,
    Temolateurl: state => state.layout.Temolateurl,
    fileurl: state => state.layout.fileurl,
    scaleUrl: state => state.layout.scaleUrl,
    qrcodeUrl: state => state.layout.qrcodeUrl,
    addRouters: state => state.routerData.addRouters,
    config: state => state.layout.config,
    token: state => state.token,
    info: state => state.role.info,
    routers: state => state.routerData.routers,
    logoShow: state => state.layout.logoShow,
    isCollapse: state => state.layout.isCollapse,
    uniquerouter: state => state.layout.uniquerouter,
    tabnavBox: state => state.layout.tabnavBox,
    visible: state => state.layout.visible,
    left: state => state.layout.left,
    top: state => state.layout.top,
    AdmNo: state => state.role.AdmNo,
    rightNav: state => state.layout.rightNav,
  },
  modules: {
    routerData,
    role,
    layout,
    eduWebConfig
  },
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js